import React from 'react';
import { Banknote, BarChart } from 'lucide-react';

const Servicos: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#f6f7f8] dark:bg-[#101922] font-sans py-20 px-6">
            <div className="max-w-7xl mx-auto">
                <h1 className="text-4xl font-bold text-slate-800 dark:text-white mb-8 text-center">Nossos Serviços</h1>
                <div className="grid grid-cols-1 gap-12 items-center md:grid-cols-2 lg:gap-20">
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-4">
                            <Banknote className="text-4xl text-[#137fec]" />
                            <h3 className="text-2xl font-bold text-slate-800 dark:text-white">Orçamentação Detalhada</h3>
                            <p className="text-slate-600 dark:text-slate-400">Crie orçamentos detalhados e precisos em minutos, não em dias. Nossa plataforma analisa cada componente do seu modelo BIM para garantir que nenhum custo seja esquecido.</p>
                        </div>
                        <div className="flex flex-col gap-4">
                            <BarChart className="text-4xl text-[#137fec]" />
                            <h3 className="text-2xl font-bold text-slate-800 dark:text-white">Análise de Viabilidade</h3>
                            <p className="text-slate-600 dark:text-slate-400">Avalie rapidamente a viabilidade financeira de diferentes cenários de projeto. Tome decisões informadas com base em dados em tempo real para maximizar seu ROI.</p>
                        </div>
                    </div>
                    <div>
                        <img className="w-full rounded-xl" alt="Engineers reviewing blueprints" src="https://lh3.googleusercontent.com/aida-public/AB6AXuD8BJgmAuJiCLE6ZUh_DXVX5ijpJfb0wxisbGChPswKVw6OdRGD-KYDx-fcgdzcRyEOzXzcSFk1l8OOkUi4Fonv7EVdcMOeYzdP9U5Yqcvd_MpE5Nf-WbF7ALhbpDNvo277e3PNG9KsYtwTum7G_0OeUYZeMQZ-R29I9LqZYdbMjN9luRAJGDbs01RsEt5G2MZ1aWZQfceVQY_D_ezfEiZOii8l-6BcbOncrDjjpO6ouyC0-xOVmItJdoeskG-p6wjmDWdhFkKF_RM" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Servicos;
